/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-overlay.html";
import { events } from "@nuskin/ns-util";

import "@nuskin/ns-style-elements";

/**
 * <p>ns-overlay sits behind other overlay components such as modals and drawers.
 *    It's z-index puts it between main content and those elements. It also locks the background from scrolling.</p>
 *
 * <h2>Demo</h2>
 * <ns-button href="#elements-app/elements/NsOverlay" onclick="window.location='/playground/ns-overlay.html';">Ns Overlay Demo</ns-button>
 *
 * <marked-element>
 *  <div slot="markdown-html">
 *  <script type="text/markdown">
 *
 *      ### Styling
 *
 *      `<ns-overlay>` provides the following custom properties and mixins for styling:
 *
 *      Custom property            | Description                           | Default
 *      ---------------------------|---------------------------------------|-------------------
 *      `--ns-overlay              | mixin applied to ns-overlay host      | `{}`
 *
 *  </script>
 * </marked-element>
 *
 */
export class NsOverlay extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-overlay";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * Indicates whether the overlay is currently open or not
       */
      opened: {
        type: Boolean,
        value: false
      },
      /**
       * Option for themeing the overlay. Options include: light, dark (default)
       */
      theme: {
        type: String,
        value: "dark"
      },
      /**
       * Allows scroll when overlay is shown
       */
      allowScroll: {
        type: Boolean
      }
    };
  }

  ready() {
    super.ready();
    events.subscribe("closeOverlay", () => {
      this.hide();
    });
    events.subscribe("openOverlay", () => {
      this.show();
    });
    events.subscribe("toggleOverlay", () => {
      this.toggle();
    });
  }

  /**
   * Display the overlay and prevent the background from scolling
   */
  show() {
    if (!this.allowScroll)
      document.getElementsByTagName("html")[0].classList.add("no-scroll");
    this.style.display = "block";
    this.opened = true;
  }

  /**
   * Hide the overlay and allow the page to scroll normally
   */
  hide() {
    if (!this.allowScroll)
      document.getElementsByTagName("html")[0].classList.remove("no-scroll");
    this.style.display = "none";
    this.opened = false;
  }

  /**
   * toggle the display of the overlay
   */
  toggle() {
    if (this.opened) {
      this.hide();
      this.opened = false;
    } else {
      this.show();
      this.opened = true;
    }
  }
}
customElements.define(NsOverlay.is, NsOverlay);
